import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    submitButton: '<md:w-full',
    formContainer: 'grid mt-6 gap-8 md:(cols-2 mt-8 gap-4)'
  },
  showLoyaltyComponent: false
} satisfies PagesConfig['profile']
